module.exports =
  '_SCORE_REGISTRATION':
    'TITLE': 'スコア登録'
    'SELECT_CLUB':
      'TITLE': 'コースの選択'
      'SEARCH': '検索'
      'HISTORY': '履歴'
      'NORESULT': "該当結果なし"
      'COURSE_REQUEST_HINT': '希望のコースが見つからない場合は追加リクエストをお送りください。'
      'COURSE_REQUEST_LINK': 'リクエスト'
      'INPUT_KEYWORDS': 'キーワードを入力してください'
      'EMAIL_SUBJECT': 'Course Request'
    'SELECT_CLUB_HISTORY':
      'NORESULT': "該当するラウンド情報がありません"
    'ROUND_INFO':
      'TITLE': 'ラウンド情報の設定'
      'HOLE_1': '1ホール'
      'HOLE_10': '10ホール'
      'COURSE_REQUEST': 'コースを選択してください'
      'START_REQUEST': 'スタートを選択してください'
      'TEE_REQUEST': 'ティーを選択してください'
      'RAKUTEN_LINK': '予約プランを見る（予約も可)'
      'PLAY_DATE': 'プレイ日'
      'WEATHER': '天気'
      'COURSE': 'コース'
      'START_HOLE': 'スタート'
      'TEE_POSITION': 'ティー'
      'EXTRA_9': 'エクストラ 9'
      'NONE': '設定なし'
      'MOVE_TO_SELECT_PLAYERS': '同伴者の設定へ'
      'CONFIRM_CLEAR_DATA': 'これより下の入力内容がクリアされますが、よろしいでしょうか？'
      'ERROR_FLASH_MESSAGE': '入力内容に問題が有ります。再度ご確認下さい。'
    'SELECT_PLAYERS':
      'SELECT_PLAYER_TITLE': '同伴者の設定'
      'PARTNER': '同伴者'
      'MOVE_TO_SCORE_REGISTRATION': 'スコアの入力へ'
      'DUPLICATE_PLAYER': 'その名前は既に登録されています。別の名前を入力してください。'
      'CONFIRM_CLEAR_SCORE': '変更した Player のスコア入力はクリアされますが、よろしいでしょうか？'
    'SCORE_ENTRY':
      'TITLE': 'スコアの入力'
    'FOOTER':
      'TITLE': 'スコア登録完了'
    'UNSAVED_HINT': 'OK ボタンを押して変更を適用して下さい。'




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/score-registration/i18n/ja.coffee